import type {
  SurveyContact,
  SurveyContactPost,
} from "@survey-types/survey.contacts.types";
import { surveyApi } from "./base";

// Survey Contacts API - handles contact management
export const surveyContactsApi = surveyApi
  .enhanceEndpoints({
    addTagTypes: ["Survey"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      addSurveyContact: build.mutation<SurveyContact, SurveyContactPost>({
        query: (contact) => ({
          url: `/contacts`,
          method: "POST",
          body: contact,
        }),
        invalidatesTags: (_result, _error, contact: SurveyContactPost) => [
          { type: "Survey", id: contact.surveyId },
        ],
      }),
      updateSurveyContact: build.mutation<
        SurveyContact,
        { contactId: string; contact: Partial<SurveyContact> }
      >({
        query: ({ contactId, contact }) => ({
          url: `/contacts/${contactId}`,
          method: "PATCH",
          body: contact,
        }),
        invalidatesTags: (_result, _error, { contact }) => [
          { type: "Survey", id: contact.surveyId },
        ],
      }),
      deleteSurveyContact: build.mutation<string, string>({
        query: (contactId) => ({
          url: `/contacts/${contactId}`,
          method: "DELETE",
        }),
        invalidatesTags: () => ["Survey"],
      }),
      reorderSurveyContact: build.mutation<
        void,
        { surveyId: string; order: number; contactId: string }
      >({
        query: ({ surveyId, order, contactId }) => ({
          url: `/contacts/reorder`,
          method: "PATCH",
          body: { surveyId, order, contactId },
        }),
        invalidatesTags: (_result, _error, { surveyId }) => [
          { type: "Survey", id: surveyId },
        ],
      }),
    }),
  });

export const {
  useAddSurveyContactMutation,
  useUpdateSurveyContactMutation,
  useDeleteSurveyContactMutation,
  useReorderSurveyContactMutation,
} = surveyContactsApi;
